import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-glyphicons',
	templateUrl:'./GlyphiconsPluginPage.html',
	styles: [],
	styleUrls:['./GlyphiconsPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class GlyphiconsPluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_597 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>glyphicons</artifactId>
</dependency>
\`\`\``;
	mdContent_598 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:glyphicons")
\`\`\``;
	mdContent_599 = `\`\`\`java
var home = new Glyphicon<>(Glyphicons.home);
var search = new Glyphicon<>(Glyphicons.search);
\`\`\``;
	mdContent_600 = `\`\`\`java
var icon = new Glyphicon<>(Glyphicons.home);
var search = new Glyphicon<>(Glyphicons.search);
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
